import IeltsImage from "../img/image.png";
import JobImage from "../img/image copy.png";
import TeledockImage from "../img/teledock.png";
import VirtualTalimImage from "../img/virtual_talim.png";

const Menu = [
	{
		id: 1,
		image: IeltsImage,
		title: "IELTS exam preparation platform",
		category: ["Full Stack"],
		url: "https://ieltspractice.net/",
		repositoryUrl: "https://github.com/realmoneycold/IELTSPRACTICE"
	},
	{
		id: 2,
		image: JobImage,
		title: "Website for people to find job",
		category: ["Full Stack"],
		url: "#",
		repositoryUrl: "#"
	},
	{
		id: 3,
		image: TeledockImage,
		title: "TeleDock",
		category: ["Telegram Bot"],
		url: "https://t.me/teledock_bot",
		repositoryUrl: "#"
	},
	{
		id: 4,
		image: VirtualTalimImage,
		title: "Virtual Ta'lim",
		category: ["Telegram Bot"],
		url: "https://t.me/TalimAmaliyot2026_bot",
		repositoryUrl: "#"
	},
	{
		id: 5,
		image: "/Maverik.png",
		title: "Maverik",
		category: ["Full Stack"],
		url: "https://timepiecelifestyle.com/maverik"
	},
	{
		id: 6,
		image: "/insider finance.png",
		title: "Insider Finance",
		category: ["Telegram Bot"],
		url: "https://t.me/InsiderFinance_bot"
	},
	{
		id: 7,
		image: "/Gamehub.jpeg",
		title: "GameCache",
		category: ["Telegram Bot"],
		url: "https://t.me/GameCacheBot",
		repositoryUrl: "https://github.com/realmoneycold/GameCache"
	},
	{
		id: 8,
		image: "/image.png",
		title: "Medlab",
		category: ["Full Stack"],
		url: "http://95.217.182.116:5174/",
		repositoryUrl: "https://github.com/realmoneycold/Medlab"
	},
	{
		id: 9,
		image: "/image copy.png",
		title: "Time Piece Lifestyle",
		category: ["Full Stack"],
		url: "https://timepiecelifestyle.com/"
	}
];

export default Menu;
